import ImageOne from '../images/clôture.webp';
import ImageTwo from '../images/portail3.webp';

export const InfoData = {
  heading: 'Notre valeur de travail réside dans la réactivité et le travail minutieux au meilleur prix en Indre-et-Loire',
  paragraphOne:
    '\u2023 Clôtures',
  paragraphTwo:
    '\u2023 Portails et portillons',
  paragraphThree:
    '\u2023 Automatismes',
    h2: 
    'Pas de TVA et devis gratuit',
  buttonLabel: 'Nous contacter',
  image: ImageOne,
  alt: 'cloture', 
  reverse: false,
  delay: 100
};

export const InfoDataTwo = {
  heading: 'Portails et Automatismes',
  paragraphOne:
    'Nous installons également des portails et portillions, aussi bien automatiques que non.',
  paragraphTwo:
    'L\u0027automatisation est une excellente façon de rendre les choses plus simples. Vous conduirez le portail à distance depuis votre maison ou votre voiture. ',
  buttonLabel: 'Obtenir un devis gratuit',
  image: ImageTwo,
  alt: 'cloture',
  reverse: true,
  delay: 300
};
